<template>
  <div >
    <div class="root" id="root" data-target="specialFeature-1691834599183">
      <div class="hCnVKxh5ABYzPjWWu0rH">
        <!--        <div class="zAsCjLdh1d8SdqBcjnJY">-->
        <!--          <div class="rndx react-draggable"-->
        <!--               style="position: absolute; user-select: auto; width: 36px; height: 36px; display: inline-block; top: 0px; left: 0px; cursor: move; transform: translate(380px, 400px); max-width: 9.0072e+15px; max-height: 9.0072e+15px; box-sizing: border-box; flex-shrink: 0;">-->
        <!--            <img class="icon" src="/webx/xc/mobile/images/outcache/Rocket@3x.6c18.png">-->
        <!--            <div></div>-->
        <!--          </div>-->
        <!--          <div class="overlay" style="display: none;"></div>-->
        <!--        </div>-->
        <div id="captcha-button"></div>
        <div id="captcha-element"></div>
        <div id="captcha-wy"></div>
        <!--        <div class="fBzbGiSmgDKW5YKdSO19">-->
        <!--          <div class="rndxs react-draggable"-->
        <!--               style="position: absolute; user-select: auto; width: 36px; height: 36px; display: inline-block; top: 0px; left: 0px; cursor: auto; transform: translate(380px, 450px); max-width: 9.0072e+15px; max-height: 9.0072e+15px; box-sizing: border-box; flex-shrink: 0;">-->
        <!--            <img class="icon" src="/webx/xc/mobile/images/outcache/icon.2af9.png">-->
        <!--            <div></div>-->
        <!--          </div>-->
        <!--          <div class="overlay" style="display: none;"></div>-->
        <!--        </div>-->
        <div class="je4cw58k8NCj0Mv2quAe">
          <div class="contents">
            <div class="box">
              <div class="infos">
                <div class="infoTop">
                  <p class="infoText">中心钱包
                    <!--                    <div class="button"><i class="bIcon"></i>一键回收</div>-->
                  </p>
                  <p class="infoMoney">{{ $store.state.userInfo.balance }}</p>
                </div>
                <div class="infoBot">
                  <p class="infoText">锁定钱包</p>
                  <p style="font-size: 18px; font-weight: 700;">{{ $store.state.userInfo.gameblance }}</p>
                </div>
                <div class="auto-tran-box"  @click="transall">
                  <p class="auto-tran-text">一键回收</p>
                  <!--                  <svg aria-hidden="true" focusable="false"-->
                  <!--                                                             data-prefix="fas" data-icon="toggle-off" class="svg-inline&#45;&#45;fa fa-toggle-off "-->
                  <!--                                                             role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"-->
                  <!--                                                             style="margin: 0px 4px 2px; color: rgba(160, 149, 198, 0.27); font-size: 26px;">-->
                  <!--                  <path fill="currentColor"-->
                  <!--                        d="M384 128c70.7 0 128 57.3 128 128s-57.3 128-128 128H192c-70.7 0-128-57.3-128-128s57.3-128 128-128H384zM576 256c0-106-86-192-192-192H192C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192zM192 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z">-->
                  <!--                  </path>-->
                  <!--                </svg>-->
                </div>
              </div>
              <div class="shield" @click="is_bing=!is_bing">

                <svg v-if="!is_bing" aria-hidden="true" focusable="false" data-prefix="fas"
                     data-icon="toggle-off" class="svg-inline--fa fa-toggle-off " role="img"
                     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"
                     style="margin: 0px 4px 2px; color: rgba(160, 149, 198, 0.27); font-size: 26px;">
                  <path fill="currentColor"
                        d="M384 128c70.7 0 128 57.3 128 128s-57.3 128-128 128H192c-70.7 0-128-57.3-128-128s57.3-128 128-128H384zM576 256c0-106-86-192-192-192H192C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192zM192 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z">
                  </path>
                </svg>


                <svg v-if="is_bing" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="toggle-on" class="svg-inline--fa fa-toggle-on "
                     role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"
                     style="margin: 0px 4px 2px; color: rgb(160, 149, 198); font-size: 26px;">
                  <path fill="currentColor"
                        d="M192 64C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192s-86-192-192-192H192zm192 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z">
                  </path>
                </svg>


                屏蔽无余额场馆
              </div>
              <div class="platform-balance">

                <div class="item" v-for="(item, index) in balancelist"  :key="index"  v-if=" index != 0 && is_bing && item.balance > 0" >
                  <p class="name">{{ item.name }}</p>
                  <p class="balance" style="color: rgba(47, 37, 71, 0.5);">{{ item.balance }}</p>
                </div>
                <div class="item" v-for="(item, index) in balancelist"  :key="index"  v-if=" index != 0 && !is_bing" >
                  <p class="name">{{ item.name }}</p>
                  <p class="balance" style="color: rgba(47, 37, 71, 0.5);">{{ item.balance }}</p>
                </div>
              </div>
            </div>
            <div class="transfer-box"  v-if="$store.state.userInfo.transferstatus == 0">
              <div class="box">
                <div class="platformBox">
                  <div class="vertical-text">从<span>...</span>到</div>
                  <div class="platform">
                    <div class="platformItem"  @click="changShow('sourcetype')">
                      <p class="platformOut">转出</p>
                      <p class="platformName">{{ sourcetype.name }}</p>
                    </div>
                    <div class="platformItem"  @click="changShow('targettype')">
                      <p class="platformEnter">转入</p>
                      <p class="platformName">{{ targettype.name }} </p>
                    </div>
                  </div><span  @click="fanzhuan()" class="platformIcon"></span>
                </div>
                <div class="boxText">存款金额</div>
                <div class="moneyBox"><button @click="getmoney(100)" class="money-button">
                  <div :class="amount == 100 ? ' moneyItem moneyItem_active' : 'moneyItem'"   ><span class="moneyText primary">100</span></div>
                </button><button  @click="getmoney(1000)"  class="money-button">
                  <div :class="amount == 1000 ? ' moneyItem moneyItem_active' : 'moneyItem'"  ><span class="moneyText primary">1000</span></div>
                </button><button  @click="getmoney(10000)"   class="money-button">
                  <div  :class="amount == 10000 ? ' moneyItem moneyItem_active' : 'moneyItem'" ><span class="moneyText primary">10000</span></div>
                </button><button  @click="bigMey"  class="money-button">
                  <div  :class="amount == $store.state.userInfo.balance ? ' moneyItem moneyItem_active' : 'moneyItem'" ><span class="moneyText primary">MAX</span></div>
                </button></div>
                <div class="amount-input"><input class="input"  v-model="amount" type="number" placeholder="请输入转账金额"
                                                 value=""><span class="inputAll">RMB</span></div>
                <button  @click="btnOk"  v-if="$store.state.userInfo.transferstatus == 0"
                         class="transfer-button">立即转账</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>









    <div class="portal-warpper">
      <div class="HZ0Aws4BaQP_ZM85k_mS undefined" style="display: flex;">
        <div class="left"  @click="$router.back()"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left"
                                                        class="svg-inline--fa fa-chevron-left " role="img" xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 320 512" style="margin: 0px 4px;">
          <path fill="currentColor"
                d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z">
          </path>
        </svg></div>
        <div class="center">平台转账</div>
        <div   @click="$parent.goNav('/message')"  class="right"><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="envelope"
                                                                      class="svg-inline--fa fa-envelope " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                                                                      style="margin: 0px 4px;">
          <path fill="currentColor"
                d="M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z">
          </path>
        </svg></div>
      </div>
    </div>


    <van-popup v-model="show" position="bottom" v-if="type == 'sourcetype' && show" :style="{ height: '70%', background: '#f8f8f8' }" class="card">
      <div class="poptit">选择钱包</div>
      <div style="height: 0.2rem"></div>
      <div style="background: #fff; width: 100%; margin: 0 auto; padding: 0 20px; box-sizing: border-box">
        <div class="lis" v-for="(item, index) in balancelist" :key="index" @click="changApiType('sourcetype', item)">
          <div>{{ item.name }}</div>
          <img v-if="sourcetype.name == item.name" src="/static/image/icon_chose.28d0a1732f077f8062a64082a086ebf2.png" alt="" />
        </div>
      </div>
    </van-popup>
    <van-popup v-model="show" position="bottom" v-if="type == 'targettype' && show" :style="{ height: '70%', background: '#f8f8f8' }" class="card">
      <div class="poptit">选择钱包</div>
      <div style="height: 0.2rem"></div>
      <div style="background: #fff; width: 100%; margin: 0 auto; padding: 0 20px; box-sizing: border-box">
        <div class="lis" v-for="(item, index) in balancelist" :key="index" @click="changApiType('targettype', item)">
          <div>{{ item.name }}</div>
          <img v-if="targettype.name == item.name" src="/static/image/icon_chose.28d0a1732f077f8062a64082a086ebf2.png" alt="" />
        </div>
      </div>
    </van-popup>




  </div>
</template>
<script>
export default {
  name: 'transfer',
  data() {
    return { is_bing:false,nshow: true, balancelist: [], openInfo: {}, amount: null, payType: 0, openShow: false, daoTime: null, showLis: 4, show: false, type: 'sourcetype', sourcetype: { platname: 'userbalance', name: '平台钱包' }, targettype: {} };
  },
  created() {
    let that = this;
    that.getbalancelist();
    // that.daoTime = setInterval(() => {
    //   that.getbalancelistNoLoding();
    // }, 1500);
  },
  methods: {
    fanzhuan(){
      let sourcetype_val = this.sourcetype.platname;
      let targettype_val = this.targettype.platname;
      this.sourcetype.platname = targettype_val;
      this.targettype.platname = sourcetype_val;

      let sourcetype_name = this.sourcetype.name;
      let targettype_name = this.targettype.name;
      this.sourcetype.name = targettype_name;
      this.targettype.name = sourcetype_name;

    },
    getmoney(val){
      this.amount = val;
    },
    bigMey() {
      let that = this;
      // console.log('1',that.sourcetype.platname)
      // if (that.sourcetype.platname == 'userbalance') {
      that.amount = that.$store.state.userInfo.balance;
      // } else {
      //   that.amount = that.sourcetype.balance * 1;
      // }
    },
    changShow(name) {
      this.type = name;
      this.show = true;
    },
    changApiType(name, val) {
      let that = this;
      that[name] = val;
      that.show = false;
      if (name == 'sourcetype') {
        that.amount = null;
      }
    },
    changShowLis(val) {
      this.showLis = val;
    },
    transall() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
          .post('/api/transall', {})
          .then(res => {
            that.showTost(1, res.message);
            that.getbalancelist();
            that.refreshusermoney();
            that.$parent.hideLoading();
          })
          .catch(res => {
            that.$parent.hideLoading();
          });
    },
    btnOk() {
      let that = this;

      if (that.sourcetype.platname == that.targettype.platname) {
        that.showTost(0, '同平台不支持互转');

        return;
      }
      if (that.sourcetype.platname != 'userbalance' && that.targettype.platname != 'userbalance') {
        that.showTost(0, '场馆内钱包不支持互转');

        return;
      }
      if (that.amount == null || that.amount == '') {
        that.showTost(0, '请输入操作金额！');
        return;
      }
      let info = { amount: that.amount, sourcetype: that.sourcetype.platname, targettype: that.targettype.platname };

      that.showLoading();
      that.$apiFun
          .post('/api/transfer', info)
          .then(res => {
            that.showTost(1, res.message);

            if (res.code === 200) {
              that.refreshusermoney();
              that.getbalancelist();
            } else {
              that.hideLoading();
            }
          })
          .catch(res => {
            that.$parent.hideLoading();
          });
    },
    isOk() {
      let that = this;

      let sourcetype = '';
      let targettype = '';

      if (that.payType == 0) {
        //转入游戏
        sourcetype = 'userbalance';
        targettype = that.openInfo.platname;
      } else {
        //转入平台
        sourcetype = that.openInfo.platname;
        targettype = 'userbalance';
      }
      let info = { amount: that.amount, sourcetype: sourcetype, targettype: targettype };
      if (that.amount == null) {
        that.showTost(0, '请输入操作金额！');
        return;
      }
      that.closeCv();

      that.showLoading();
      that.$apiFun.post('/api/transfer', info).then(res => {
        that.showTost(1, res.message);

        if (res.code === 200) {
          that.refreshusermoney();
          that.getbalancelist();
        } else {
          that.hideLoading();
        }
      });
    },
    closeCv() {
      let that = this;
      that.openInfo = {};
      that.amount = null;
      that.openShow = false;
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        that.hideLoading();
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    getBalances() {
      let that = this;
      that.showLoading();
      that.getbalancelist();

      that.$apiFun
          .post('/api/balance', {})
          .then(res => {
            if (res.code == 200) {
              let userInfo = JSON.parse(localStorage.getItem('userInfo'));
              userInfo.balance = res.data.balance;
              localStorage.setItem('userInfo', JSON.stringify(userInfo));
              that.$store.commit('changUserInfo');
            }
            that.hideLoading();
          })
          .catch(res => {
            // console.log(res)
            that.hideLoading();
          });
    },
    changeTasfer() {
      let that = this;
      that.$parent.showLoading();
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      let mianzhuan = userInfo.transferstatus ? 0 : 1;

      that.$apiFun
          .post('/api/uptransferstatus', { transferstatus: mianzhuan })
          .then(res => {
            if (res.code != 200) {
              that.$parent.showTost(0, res.message);
            }
            if (res.code == 200) {
              userInfo.transferstatus = mianzhuan;
              localStorage.setItem('userInfo', JSON.stringify(userInfo));
              that.$store.commit('changUserInfo');
              that.$parent.showTost(1, '操作成功！');
            }
            that.$parent.hideLoading();
          })
          .catch(res => {
            that.$parent.hideLoading();
          });
    },
    changVal(item) {
      let that = this;
      // $store.state.userInfo.transferstatus == 0  0  转账模式  1免转模式
      if (that.$store.state.userInfo.transferstatus == 1) {
        return;
      }
      that.openInfo = item;
      that.openShow = true;
      that.amount = null;
    },
    close() {
      that.openInfo = {};
      that.openShow = false;
      that.amount = null;
    },
    getbalancelist() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
          .post('/api/balancelist', {})
          .then(res => {
            if (res.code !== 200) {
              that.$parent.showTost(0, res.message);
            }
            if (res.code === 200) {
              that.balancelist = res.data;
              let balancelist = res.data;
              balancelist.unshift({ platname: 'userbalance', name: '平台钱包' });
              that.balancelist = balancelist;

              if(!that.targettype.name){
                that.targettype = balancelist[1];
              }
            }
            that.$parent.hideLoading();
          })
          .catch(res => {
            that.$parent.hideLoading();
          });
    },
    getbalancelistNoLoding() {
      let that = this;

      that.$apiFun
          .post('/api/balancelist', {})
          .then(res => {
            if (res.code !== 200) {
              that.$parent.showTost(0, res.message);
            }
            if (res.code === 200) {
              that.balancelist = res.data;
              let balancelist = res.data;
              balancelist.unshift({ platname: 'userbalance', name: '平台钱包' });
              that.balancelist = balancelist;
            }
          })
          .catch(res => {});
    },

    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
};
</script>
<style lang="scss" scoped>
.tabVox {
  background: #f1f1f1;
  display: flex;
  justify-content: space-between;
  height: 1.2rem;
  align-items: center;
  padding-top: 5px;

  .tab {
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.4rem;
  }

  .tab.atc {
    background: #fff;
    border-radius: 10px 10px 0 0;
    color: #597ef7;
    position: relative;
  }

  .atc::after {
    content: ' ';
    position: absolute;
    bottom: 2px;
    width: 30px;
    height: 3px;
    left: calc(50% - 15px);
    z-index: 200;
    background: #597ef7;
    border-radius: 4px;
  }
}

.qibao {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 1.4rem;
  box-sizing: border-box;
  border-bottom: 1px solid #f8f8f8;

  .fes {
    font-size: 0.4rem;
    font-weight: 700;
  }

  .imgs {
    flex: 1;

    img {
      width: 0.4rem;
      margin-left: 0.1rem;
      display: flex;
      align-items: center;
    }
  }

  .btns {
    color: #697b8c;
    font-size: 0.28rem;
  }
}

.mesg {
  display: flex;
  align-items: center;
  height: 2rem;
  border-bottom: 1px solid #f8f8f8;

  .bosgf {
    flex: 1;
    text-align: center;

    .top {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.4rem;

      img {
        width: 0.4rem;
        margin-right: 0.1rem;
      }
    }

    .bots {
      margin-top: 0.1rem;
      font-size: 0.5rem;
      color: #597ef7;

      span {
        font-size: 0.23rem;
      }
    }
  }
}

.gameBox {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 10px;

  .lis {
    width: 25%;
    text-align: center;
    box-sizing: border-box;
    padding-top: 0.4rem;

    .name {
      font-size: 0.23rem;
      color: #383b43;
      line-height: 1;
      overflow: hidden; //超出隐藏
      text-overflow: ellipsis; //显示省略号
      white-space: nowrap; //强制不换行
    }

    .num {
      font-size: 0.23rem;
      color: #cbced8;
      margin-top: 0.2rem;
    }

    img {
      width: 0.32rem;
    }
  }
}

.usrse {
  background: #fff;
  box-sizing: border-box;
  padding-top: 5px;

  .hgs {
    width: calc(100% - 40px);
    margin: 0 auto;
  }

  .nams {
    font-size: 0.38rem;
    color: #000;
    vertical-align: middle;
    margin-top: 10px;
    font-weight: 700;
  }

  .imgsa {
    position: relative;
    height: 2rem;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 0.2rem;

    .bisn {
      width: 0.8rem;
      position: absolute;
      bottom: 0.3rem;
      left: 1.4rem;
    }

    img {
      width: 2rem;
      border-radius: 50%;
    }
  }
}

.card {
  .lis {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    height: 1.2rem;
    height: 2rem;
    font-size: 18px;
    border-bottom: 1px solid #f8f8f8;
    img {
      width: 0.4rem;
    }
  }
}

.poptit {
  height: 1.4rem;
  font-size: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 22;
  height: 2rem;
  font-size: 0.8rem;
}

.cardhgs {
  display: flex;
  align-items: center;
  color: #597ef7;
  font-size: 0.23rem;
  height: 1.2rem;

  img {
    width: 0.8rem;
    margin: 0 1rem;
  }

  span {
    display: inline-block;
    margin: 0 4px;
    font-size: 0.23rem;
  }
}

.mianzhuan {
  display: flex;
  height: 2rem;
  align-items: center;
  margin: 14px auto;
  box-sizing: border-box;
  padding: 0 20px;
  background: #fff;

  .lfs {
    flex: 1;
    font-weight: 700;
    font-size: 0.4rem;
  }

  .ces {
    color: #a5a9b3;
    padding-right: 10px;
    font-size: 0.3rem;
  }
}

.zhuanzang {
  background: #fff;
  box-sizing: border-box;
  padding: 0 20px;
  .tit {
    display: flex;
    align-items: center;
    height: 1.2rem;
    border-bottom: 1px solid #f8f8f8;
    img {
      width: 0.6rem;
    }
    .lesg {
      width: calc(50% - 0.6rem);
      display: flex;
      justify-content: center;
      font-size: 0.4rem;
      font-weight: 700;
      justify-content: center;
      span {
        color: #a5a9b3;
        font-size: 0.4rem;
        padding-left: 10px;
      }
    }
  }
}
p {
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  unicode-bidi: isolate;
}

body>div#root {
  height: 100%;
  overflow: hidden;
  background-color: #fafaff;
}


.hCnVKxh5ABYzPjWWu0rH {
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  background-repeat: repeat;
  background: #fff;
}

body>div#root>div {
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: auto;
}

div, span, a {
  user-select: none;
  -webkit-overflow-scrolling: touch;
}
.fBzbGiSmgDKW5YKdSO19 .rndxs {
  position: relative;
  z-index: 199;
}

.overlay {
  width: 100%;
  height: 100vh;
  opacity: 0;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 100;
  overflow: hidden;
}


.je4cw58k8NCj0Mv2quAe {
  height: calc(100% - 2.4rem);
  box-sizing: border-box;
  margin-top: 2.4rem;
  position: relative;
  overflow-y: auto;
}
.je4cw58k8NCj0Mv2quAe .box .button i {
  display: inline-block;
  width: 15px;
  height: 15px;
  background: url(/webx/xc/mobile/images/outcache/ic-money.17de.png) no-repeat center;
  background-size: 100% 100%;
  position: relative;
  top: 3px;
  left: -3px;
}


.je4cw58k8NCj0Mv2quAe .box .button {
  height: 25px;
  min-width: 80px;
  background: url(/webx/xc/mobile/images/outcache/Rectangle.8734.png) no-repeat center;
  border: none;
  color: #fff;
  border-radius: 31px;
  font-size: 12px;
  font-weight: 400;
  line-height: 25px;
  text-indent: 12px;
  margin-left: 6px;
}

.je4cw58k8NCj0Mv2quAe .contents {
  padding: 15px;
}

.je4cw58k8NCj0Mv2quAe .box {
  background: #f7f7f7;
  border-radius: 16px;
}

.je4cw58k8NCj0Mv2quAe .box .infos {
  height: 170px;
  margin-bottom: 10px;
  color: #fff;
  background: url(/webx/xc/mobile/images/outcache/bg-center.b867.jpg) no-repeat center;
  background-size: 100% 100%;
  position: relative;
}


.je4cw58k8NCj0Mv2quAe .box .infos .infoTop {
  padding-left: 14px;
  padding-top: 22px;
}

.je4cw58k8NCj0Mv2quAe .box .infoText {
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  display: flex;
  align-items: center;
}
p {
  margin-block-start: 5px !important;
  margin-block-end: 5px !important;
}
.je4cw58k8NCj0Mv2quAe .box .button {
  height: 25px;
  min-width: 80px;
  background: url(/webx/xc/mobile/images/outcache/Rectangle.8734.png) no-repeat center;
  border: none;
  color: #fff;
  border-radius: 31px;
  font-size: 12px;
  font-weight: 400;
  line-height: 25px;
  text-indent: 12px;
  margin-left: 6px;
}

.je4cw58k8NCj0Mv2quAe .box .infos .infoMoney {
  font-size: 24px;
  font-weight: 700;
}

.je4cw58k8NCj0Mv2quAe .box .infos .infoBot {
  padding-left: 14px;
  padding-top: 32px;
}
.je4cw58k8NCj0Mv2quAe .box .infoText {
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  display: flex;
  align-items: center;
}

.je4cw58k8NCj0Mv2quAe .auto-tran-box {
  display: flex;
  align-items: center;
  width: 5.7375rem;
  height: 1.75rem;
  text-align: center;
  top: 0;
  position: absolute;
  right: 0;
  justify-content: space-evenly;
  text-indent: 10px;
  background: url(/webx/xc/mobile/images/outcache/r-Rectangle.8ebc.png) no-repeat center;
  background-size: 100% 100%;
  margin-top: 18px;
}

.je4cw58k8NCj0Mv2quAe .auto-tran-box .auto-tran-text {
  font-size: 12px;
  font-weight: 400;
  color: #fff;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}
.je4cw58k8NCj0Mv2quAe .box .shield {
  display: flex;
  justify-content: flex-start;
  text-align: center;
  color: #767677;
  font-size: 13px;
  font-weight: 400;
  padding-bottom: 10px;
  align-items: center;
}

.je4cw58k8NCj0Mv2quAe .box .platform-balance {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.je4cw58k8NCj0Mv2quAe .box .item {
  margin-bottom: 20px;
  width: 33%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.je4cw58k8NCj0Mv2quAe .box .platform-balance .item:not(:nth-child(3n)) {
  border-right: 1px solid;
  border-image: linear-gradient(180deg, rgba(47, 39, 71, 0.004) 0%, rgba(77, 77, 77, 0.1) 44.79%, rgba(77, 77, 77, 0.004) 100%);
}

.je4cw58k8NCj0Mv2quAe .box .name {
  color: rgba(47, 37, 71, .5);
  width: "100%";
  text-align: center;
  font-weight: 400;
  font-size: 14px;
}

.je4cw58k8NCj0Mv2quAe .box .balance {
  width: 100%;
  text-align: center;
  color: rgba(47, 37, 71, .5);
  font-weight: 700;
  font-size: 14px;
}

.je4cw58k8NCj0Mv2quAe .box {
  background: #f7f7f7;
  border-radius: 16px;
}

.je4cw58k8NCj0Mv2quAe .transfer-box .box {
  border: none;
  background: none;
  display: grid;
}

.je4cw58k8NCj0Mv2quAe .transfer-box .platformBox {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  align-items: stretch;
}

.je4cw58k8NCj0Mv2quAe .transfer-box .platformBox .vertical-text {
  writing-mode: vertical-rl;
  text-orientation: upright;
  text-align: center;
}

.je4cw58k8NCj0Mv2quAe .transfer-box .platformBox .vertical-text span {
  color: #daccff;
}

.je4cw58k8NCj0Mv2quAe .transfer-box .platform {
  display: flex;
  height: 96px;
  align-items: center;
  flex-direction: column;
  width: 14.875rem;
  width: 80%;
  justify-content: center;
}

.je4cw58k8NCj0Mv2quAe .transfer-box .platform .platformItem {
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  background-color: #fff;
  border-bottom: 1px solid rgba(217, 217, 217, .8);
  justify-content: flex-start;
  flex-direction: row;
  line-height: 40px;
}

.je4cw58k8NCj0Mv2quAe .transfer-box .platform .platformOut {
  width: 37px;
  height: 21px;
  font-size: 12px;
  font-weight: 400;
  color: #376caa;
  background: #cee4fe;
  text-align: center;
  line-height: 21px;
  margin: 0 10px;
  border-radius: 3px;
}

.je4cw58k8NCj0Mv2quAe .transfer-box .platform .platformName {
  text-align: center;
  color: rgba(47, 39, 71, .8);
  font-size: 14px;
  font-weight: 700;
}


.je4cw58k8NCj0Mv2quAe .transfer-box .platform .platformEnter {
  width: 37px;
  height: 21px;
  font-size: 12px;
  font-weight: 400;
  color: #5bba5b;
  background: #e7f7e7;
  text-align: center;
  line-height: 21px;
  margin: 0 10px;
  border-radius: 3px;
}

.je4cw58k8NCj0Mv2quAe .transfer-box .platform .platformName {
  text-align: center;
  color: rgba(47, 39, 71, .8);
  font-size: 14px;
  font-weight: 700;
}

.je4cw58k8NCj0Mv2quAe .transfer-box .platformBox .platformIcon {
  width: 38px;
  height: 38px;
  display: inline-block;
  background: url(/webx/xc/mobile/images/outcache/ic-transfer.e4d0.png) no-repeat center;
  background-size: 100% 100%;
  margin-top: 28px;
}

.je4cw58k8NCj0Mv2quAe .transfer-box .boxText {
  font-size: 17px;
  font-weight: 400;
  color: #2f2747;
  margin: 13px 17px;
}

.je4cw58k8NCj0Mv2quAe .transfer-box .moneyBox {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.je4cw58k8NCj0Mv2quAe .transfer-box .money-button {
  background: none;
  border: none;
  padding: 0px;
  width: 22%;
  margin: 0 4px;
}

.je4cw58k8NCj0Mv2quAe .transfer-box .money-button .moneyItem {
  background: linear-gradient(180deg, rgba(240, 234, 255, 0.53) 0%, #ECE8FF 100%);
  color: #c4b2ff;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  width: 100%;
  height: 30px;
  margin-top: 10px;
  display: flex;
}

.je4cw58k8NCj0Mv2quAe .transfer-box .money-button .moneyItem_active {
  //background: linear-gradient(180deg, rgba(240, 234, 255, 0.53) 0%, #ECE8FF 100%);
  //color: #c4b2ff;
  border:1px solid #A787E7;
  background: #A787E7;
  //color: #ffffff;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  width: 100%;
  height: 30px;
  margin-top: 10px;
  display: flex;
}


.je4cw58k8NCj0Mv2quAe .transfer-box .money-button .moneyText {
  color: #c4b2ff;
  font-size: 12px;
}


.je4cw58k8NCj0Mv2quAe .transfer-box .money-button .moneyItem_active .moneyText{
  color: #fff;
  font-size: 12px;
}


.je4cw58k8NCj0Mv2quAe .transfer-box .amount-input {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  border: 1px solid rgba(160, 149, 198, .2);
  margin: 20px 0px;
}

.je4cw58k8NCj0Mv2quAe .transfer-box .amount-input .input {
  height: 36px;
  border-radius: 4px;
  padding-right: 10px;
  background-color: #fafaff;
  border: none;
  flex: 4;
  padding-left: 5px;
}

.je4cw58k8NCj0Mv2quAe .transfer-box .amount-input .inputAll {
  font-size: 18px;
  font-weight: 400;
  color: rgba(47, 39, 71, .6);
  width: 18%;
  text-align: center;
  height: 100%;
  line-height: 36px;
}

.je4cw58k8NCj0Mv2quAe .transfer-box .transfer-button {
  height: 50px;
  width: 90%;
  border: none;
  background: url(/webx/xc/mobile/images/outcache/btn.8cb6.png) no-repeat center;
  background-size: 100% 100%;
  font-size: 18px;
  color: #fff;
  line-height: 50px;
  text-align: center;
  font-weight: 700;
  font-style: normal;
  font-family: "Microsoft YaHei UI";
  text-transform: uppercase;
  letter-spacing: .355rem;
  margin: 0 auto;
}

.HZ0Aws4BaQP_ZM85k_mS {
  height: 2.4rem;
  justify-content: space-between;
  align-items: center;
  display: flex;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 5;
  background: #fff;
  border-bottom: 1px solid rgba(217, 217, 217, .22);
}

.HZ0Aws4BaQP_ZM85k_mS>div.left {
  width: 10%;
}

.HZ0Aws4BaQP_ZM85k_mS>div.left>svg {
  font-size: .8533rem;
  padding: .64rem .4rem;
}

.HZ0Aws4BaQP_ZM85k_mS>div.center {
  position: absolute;
  left: 20%;
  width: 60%;
  text-align: center;
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  color: #0c0319;
}

.HZ0Aws4BaQP_ZM85k_mS>div.right {
  width: 30%;
  display: flex;
  justify-content: flex-end;
}


.HZ0Aws4BaQP_ZM85k_mS>div.right>svg {
  color: #593f6c;
  font-size: .8533rem;
}

.HZ0Aws4BaQP_ZM85k_mS>div.right>svg:nth-last-child(1) {
  margin-right: .5333rem !important;
}


.je4cw58k8NCj0Mv2quAe .box .infos .infoBot {
  padding-left: 14px;
  padding-top: 32px;
}

.je4cw58k8NCj0Mv2quAe .box .infoText {
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  display: flex;
  align-items: center;
}

.fg6ZfskHOnqaRwP2znAd {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .6);
  top: 0;
  left: 0;
  position: fixed;
  transform: translateZ(500px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.IMXCn5ydwEw_jJmmMHBA {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 0;
}

.xB_gF9WZa7pfIzh7CjSA {
  height: 100%;
  position: absolute;
  width: 100%;
  left: 0;
  z-index: 1;
  background: #fff;
  border-top-left-radius: 1.066667rem;
  border-top-right-radius: 1.066667rem;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, .2), 0px 24px 38px 3px rgba(0, 0, 0, .14), 0px 9px 46px 8px rgba(0, 0, 0, .12);
  transform: translate3d(0, 100%, 0);
  animation: an-pop-up .5s forwards;
  overflow: hidden;
}

.xB_gF9WZa7pfIzh7CjSA>.title {
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: .746667rem;
  font-weight: bold;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  color: #4c4c4c;
  box-sizing: border-box;
  z-index: 2;
}

.xB_gF9WZa7pfIzh7CjSA>.title>span {
  position: absolute;
  right: 0;
}
.xB_gF9WZa7pfIzh7CjSA>.title>span>svg {
  font-size: .853333rem;
  padding: .8rem;
}

.xB_gF9WZa7pfIzh7CjSA>.wrapper {
  height: calc(100% - 3.1875rem);
  margin-top: 3.1875rem;
  overflow: scroll;
  overscroll-behavior: contain;
  box-sizing: border-box;
  position: relative;
}

.platform-box .popupItems {
  height: 87px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background: rgba(223, 220, 233, .3);
  border-radius: 10px;
  margin-bottom: 5px;
}

.platform-box .bg {
  background: url(/webx/xc/mobile/images/outcache/bg-rectangle.7ac1.png) no-repeat center;
  background-size: 100% 100%;
}

.platform-box .popupLeftImg {
  width: 55px;
  height: 55px;
  display: inline-block;
  margin: 0 15px;
}

.platform-box .popupLeftImg.lottery {
  background: url(/webx/xc/mobile/images/outcache/lottery.8782.png) no-repeat center;
  background-size: 100% 100%;
}


.platform-box .popupText {
  color: rgba(47, 39, 71, .5);
  display: flex;
  flex-direction: column;
  align-items: normal;
  width: 70%;
}

.platform-box .popupText .text {
  font-size: 14px;
  font-weight: 400;
}
.platform-box .popupText .money {
  color: #2f2727;
  font-size: 14px;
  font-weight: 700;
}

.platform-box .popupRightImg {
  width: 20px;
  height: 20px;
  display: inline-block;
  margin: 0 15px;
  background: url(/webx/xc/mobile/images/outcache/vector-act.f113.png) no-repeat center;
  background-size: 100% 100%;
}

.platform-box .img-act {
  background: url(/webx/xc/mobile/images/outcache/vector.e1ca.png);
  background-size: 100% 100%;
}


.block {
  display: block !important;
}


</style>


